import { isBrowserRenderable } from './imageUtils';

/**
 * Decide which URL the wizard's "Uploaded Images" tile should hand to its
 * `<img>` element, given an upload-context image item.
 *
 * Order of preference:
 * 1. A server-side rendition URL (`thumbnailUrl`) — best and final.
 * 2. Placeholder when there is no local File (edit mode loaded existing images).
 * 3. Placeholder when the local File's format is one the browser cannot decode
 *    inside `<img>` (TIFF, RAW, HEIC outside Safari). Without this branch the
 *    `<img>` decode fails, `useImageRetry` exhausts its budget in ~7s, and we
 *    surface a misleading "No Image Available" tile while the server-side
 *    rendition is still being generated by the image processor Lambda.
 * 4. Otherwise, a fresh blob URL of the local File.
 *
 * The blob-URL construction is injected so callers can attach their own cache
 * (the wizard caches by `imageId-name-size` so revoking happens centrally).
 */
export const selectPreviewUrl = (
  item: { thumbnailUrl?: string; file?: File | null },
  placeholderUrl: string,
  createBlobUrl: (file: File) => string,
): string => {
  if (item.thumbnailUrl) return item.thumbnailUrl;
  if (!item.file) return placeholderUrl;
  if (!isBrowserRenderable(item.file)) return placeholderUrl;
  try {
    return createBlobUrl(item.file);
  } catch {
    return placeholderUrl;
  }
};
